exports.serviceTypes = {
    'rydehelp':'RydeHELP',
    'rydeflash': 'RydeFLASH',
    'rydeluxe': 'RydeLUXE',
    'rydepet': 'RydePET',
    'rydepool': 'RydePOOL',
    'rydesend': 'RydeSEND',
    'rydetaxi': 'RydeTAXI',
    'rydex': 'RydeX',
    'rydexl': 'RydeXL',
    'rydehire': 'RydeHIRE',
    'rydeluxexl': 'RydeLUXE',
    'rydepetxl': 'RydePET XL',
    'rydexgo': 'RydeX GO',
}

exports.supportedFileTypes = {
    "image/png": "png",
    "image/jpeg": "jpeg",
    "application/pdf": "pdf",
    "application/msword": "doc",
    "video/mp4": "mp4"
}

exports.formsWithNoTripId = {
    18230302516249: "My App crashed",
    4410772231961: "Dormant accounts",
    18443816997913: "I want to delete my Ryde account"
}

exports.feeWaiverArticleId = {
    18229758389017: "Cancellation Fee Waiver Request",
    27085468660505: "Waiting Fee Waiver Request"
}
